import * as React from "react";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { TextLoca } from "./TextLoca";
export var TextLocaValueProportional = function (_a) {
    var available = _a.available, required = _a.required, className = _a.className;
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(available)],
        [ReplacementLoca.one_1, utilNumber.format(required)],
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextLoca, { className: className, id: IdLoca.value_proportional_value, replacements: locaReplacements })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/text/TextLocaValueProportional.tsx
// module id = 139
// module chunks = 3